import { createElement } from 'react';
import { Radio as OriginalRadio } from 'antd';
const Radio = function Radio({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalRadio, { ..._otherProps }, _otherProps.children));
};
export default Radio;
